import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  menuOpen = false;
  isScrolled = false;

  @HostListener('window:scroll')
  onScroll(): void {
    this.isScrolled = window.scrollY > 40;
  }

  scrollTo(selector: string, event: Event): void {
    event.preventDefault();
    this.menuOpen = false;
    const target = document.querySelector(selector) as HTMLElement;
    if (!target) return;
    const offset = window.innerWidth < 768 ? 20 : 10;
    window.scroll({ top: target.offsetTop - offset, behavior: 'smooth' });
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }
}
